import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaLock, FaEye, FaVideo, FaGem } from 'react-icons/fa';

const features = [
  {
    icon: <FaVideo className="w-8 h-8" />,
    title: "Premium Content",
    description: "Access exclusive adult videos and content"
  },
  {
    icon: <FaHeart className="w-8 h-8" />,
    title: "Private Shows",
    description: "Enjoy intimate one-on-one experiences"
  },
  {
    icon: <FaEye className="w-8 h-8" />,
    title: "HD Quality",
    description: "Crystal clear high-definition videos"
  },
  {
    icon: <FaLock className="w-8 h-8" />,
    title: "Secure & Private",
    description: "Your privacy and security are our top priority"
  }
];

const membershipTiers = [
  {
    name: "Free",
    price: "$0",
    features: [
      "Limited video access",
      "Standard quality",
      "Basic features",
      "Community access"
    ]
  },
  {
    name: "Premium",
    price: "$15",
    features: [
      "Unlimited video access",
      "HD quality streaming",
      "Download videos",
      "Private messaging",
      "No ads",
      "Priority support"
    ],
    highlighted: true
  }
];

export default function Landing() {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-red-900/50 to-black z-0"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 relative z-10">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-extrabold mb-6 bg-gradient-to-r from-red-500 to-pink-500 bg-clip-text text-transparent">
              Welcome to Your Adult Paradise
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto">
              Discover a world of exclusive adult content, featuring the hottest videos and most beautiful performers.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
              <Link
                to="/register"
                className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-red-600 to-pink-600 rounded-full font-bold text-lg hover:from-red-700 hover:to-pink-700 transition-all duration-200 transform hover:scale-105"
              >
                Join Now
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="bg-black/50 py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-red-500">
            Why Choose Us?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-black/30 backdrop-blur-lg rounded-xl p-6 transform hover:scale-105 transition-transform duration-200"
              >
                <div className="text-red-500 mb-4">{feature.icon}</div>
                <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                <p className="text-gray-400">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Membership Tiers */}
      <div className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-red-500">
            Choose Your Plan
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {membershipTiers.map((tier, index) => (
              <div
                key={index}
                className={`rounded-xl p-8 transform hover:scale-105 transition-transform duration-200 ${
                  tier.highlighted
                    ? 'bg-gradient-to-br from-red-600 to-pink-600 text-white'
                    : 'bg-black/30 backdrop-blur-lg'
                }`}
              >
                <h3 className="text-2xl font-bold mb-2">{tier.name}</h3>
                <div className="text-3xl font-bold mb-6">{tier.price}</div>
                <ul className="space-y-4">
                  {tier.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center">
                      <FaGem className="w-5 h-5 mr-2" />
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/register"
                  className={`mt-8 block w-full py-3 text-center rounded-lg font-medium transition-colors ${
                    tier.highlighted
                      ? 'bg-white text-red-600 hover:bg-gray-100'
                      : 'bg-red-600 text-white hover:bg-red-700'
                  }`}
                >
                  Get Started
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-gradient-to-r from-red-600 to-pink-600 py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Join Our Adult Community Today
          </h2>
          <p className="text-xl mb-8">
            Experience the best adult content with our premium membership.
          </p>
          <Link
            to="/register"
            className="inline-block px-8 py-4 bg-white text-red-600 rounded-full font-bold text-lg hover:bg-gray-100 transition-colors"
          >
            Start Watching Now
          </Link>
        </div>
      </div>
    </div>
  );
}